import { InjectionToken, inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Full page load, not router navigation: maintenance.html is outside the Angular app. Replaced in tests. */
export const PAGE_REDIRECT = new InjectionToken<(url: string) => void>('PAGE_REDIRECT', {
  providedIn: 'root',
  factory: () => (url: string) => { window.location.href = url; }
});

/** On HTTP 503, opens the maintenance page with the current path as `redirect`; the error is passed on. */
export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const redirect = inject(PAGE_REDIRECT);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 503) {
        redirect('/maintenance.html?redirect=' + encodeURIComponent(window.location.pathname));
      }
      return throwError(() => error);
    })
  );
};
